import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconMedal({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<filter
					id="a"
					width="122.2%"
					height="121.8%"
					x="-11.1%"
					y="-5.5%"
					filterUnits="objectBoundingBox"
				>
					<feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
					<feGaussianBlur
						in="shadowOffsetOuter1"
						result="shadowBlurOuter1"
						stdDeviation={0.5}
					/>
					<feColorMatrix
						in="shadowBlurOuter1"
						result="shadowMatrixOuter1"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
					/>
					<feMerge>
						<feMergeNode in="shadowMatrixOuter1" />
						<feMergeNode in="SourceGraphic" />
					</feMerge>
				</filter>
				<path
					id="b"
					d="M10.646 14.65q-.203.157-.405.052l-1.587-.877-1.586.877q-.202.105-.405-.052a.41.41 0 0 1-.169-.404l.304-1.824-1.282-1.299a.36.36 0 0 1-.085-.403.38.38 0 0 1 .32-.263l1.756-.281.81-1.65q.101-.245.337-.245t.338.246l.81 1.649 1.755.28a.38.38 0 0 1 .32.264.36.36 0 0 1-.084.403l-1.282 1.299.303 1.824a.41.41 0 0 1-.168.404"
				/>
			</defs>
			<g
				fill="none"
				fillRule="evenodd"
				filter="url(#a)"
				transform="translate(3 3.187)"
			>
				<path
					fill="#CD0400"
					fillRule="nonzero"
					d="M4.553 6.816a6.9 6.9 0 0 1 3.713-1.86L5.936.921Q5.599.359 4.992.359H1.246q-.337 0-.49.299a.52.52 0 0 0 .05.579zm9.585 0 3.746-5.58a.52.52 0 0 0 .05-.578.51.51 0 0 0-.488-.299h-3.747q-.607 0-.945.562l-2.328 4.035a6.9 6.9 0 0 1 3.712 1.86M9.346 18.325q2.464 0 4.201-1.807 1.74-1.807 1.739-4.369t-1.739-4.368-4.201-1.807q-2.465 0-4.22 1.824-1.72 1.79-1.72 4.351t1.738 4.369q1.738 1.807 4.202 1.807"
				/>
				<path
					fill="#FFF"
					fillRule="nonzero"
					d="M3.862 6.456a6.9 6.9 0 0 1 3.712-1.86L5.246.562Q4.908 0 4.3 0H.554Q.217 0 .065.298a.52.52 0 0 0 .05.58zm9.585 0L17.193.877a.52.52 0 0 0 .05-.579.51.51 0 0 0-.489-.298h-3.746q-.607 0-.945.561L9.734 4.597a6.9 6.9 0 0 1 3.713 1.86Zm-4.793 11.51q2.465 0 4.202-1.807t1.738-4.37q0-2.56-1.738-4.368-1.738-1.806-4.202-1.807c-2.464-.001-3.048.608-4.218 1.825q-1.722 1.79-1.722 4.35 0 2.563 1.739 4.37 1.738 1.806 4.201 1.807"
				/>
				<mask id="c" fill="#fff">
					<use xlinkHref="#b" />
				</mask>
				<use xlinkHref="#b" fill="#CD0400" fillRule="nonzero" />
				<g fill="#FFF" mask="url(#c)">
					<path d="M4.435 6.968a.26.26 0 0 1 .09-.349.24.24 0 0 1 .334.094.26.26 0 0 1-.09.348.24.24 0 0 1-.334-.093m2.731 3.016a.24.24 0 0 1 .335.093.26.26 0 0 1-.09.348.24.24 0 0 1-.334-.093.26.26 0 0 1 .09-.348m.537.746a.24.24 0 0 1 .335-.093.26.26 0 0 1 .09.347.24.24 0 0 1-.335.094.26.26 0 0 1-.09-.348m.825.366c0-.14.11-.254.245-.254a.25.25 0 0 1 .245.254.25.25 0 0 1-.245.255.25.25 0 0 1-.245-.255m.89-.112a.26.26 0 0 1 .09-.347.24.24 0 0 1 .335.093.26.26 0 0 1-.09.348.24.24 0 0 1-.335-.094m.718-.559a.26.26 0 0 1-.09-.348.24.24 0 0 1 .335-.093.26.26 0 0 1 .09.348.24.24 0 0 1-.335.093M7.059 14.09a.25.25 0 0 1 .245.254c0 .121-.08.222-.189.248l-.056.007a.25.25 0 0 1-.245-.255c0-.14.11-.254.245-.254m3.43.509a.25.25 0 0 1-.245-.254.25.25 0 0 1 .245-.255.25.25 0 0 1 .245.255.25.25 0 0 1-.245.254m-.107-.926a.24.24 0 0 1-.335-.093.26.26 0 0 1 .09-.348.24.24 0 0 1 .334.093.26.26 0 0 1-.09.348m-.537-.745a.24.24 0 0 1-.335.093.26.26 0 0 1-.09-.348.24.24 0 0 1 .335-.094.26.26 0 0 1 .09.349m-.825-.367a.25.25 0 0 1-.245.255.25.25 0 0 1-.245-.255c0-.14.11-.254.245-.254a.25.25 0 0 1 .245.254m-.89.112a.26.26 0 0 1-.09.348.24.24 0 0 1-.335-.094.26.26 0 0 1 .09-.347.24.24 0 0 1 .335.093m-.718.56a.26.26 0 0 1 .09.347.24.24 0 0 1-.334.094.26.26 0 0 1-.09-.349.24.24 0 0 1 .334-.093m1.896-1.298a.26.26 0 0 1 .09-.349.24.24 0 0 1 .335.094.26.26 0 0 1-.09.348.24.24 0 0 1-.335-.093m-1.445 0a.26.26 0 0 1 .09-.349.24.24 0 0 1 .335.094.26.26 0 0 1-.09.348.24.24 0 0 1-.335-.093" />
				</g>
			</g>
		</svg>
	);
}
